export default "__VITE_ASSET__ci$wtSqu__"